import { useMarkerContext } from 'features/pointClouds'
import React from 'react'
import { Vector2 } from 'three'
import { GeckoSiteObservation, TicketStatus } from 'types'

import Indicator from './Indicator'
import { MarkerBall } from './MarkerBall'

interface ObservationMarkerProps {
  observation: GeckoSiteObservation
}

export const ObservationMarker: React.FC<ObservationMarkerProps> = ({
  observation,
}) => {
  const { handleMarkerActivate, startTooltipHideTimer } = useMarkerContext()

  const position = observation.data?.pointCloudCoordinates?.coordinate
  if (!position) {
    return null
  }
  const handleActivate = (observationId: string, mouseEvent: MouseEvent) => {
    const mousePosition = new Vector2(
      mouseEvent.clientX - 100,
      mouseEvent.clientY - 380
    )

    handleMarkerActivate(observationId, mousePosition)
  }

  const isNew = observation.data.status === TicketStatus.NEW

  return (
    <>
      <Indicator position={position} isVisible={isNew} />
      <MarkerBall
        observation={observation}
        onActivate={(mouseEvent) => handleActivate(observation.id, mouseEvent)}
        onDeactivate={startTooltipHideTimer}
      />
    </>
  )
}
